import Vue from "vue";
import VueMaterial from "vue-material";
import VueParticles from "vue-particles";
import VueTruncate from "vue-truncate-filter";
import VueTheMask from "vue-the-mask";
import VeeValidate, { Validator } from "vee-validate";
import VeePtBr from "vee-validate/dist/locale/pt_BR";
import SocialSharing from "vue-social-sharing";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.scss";

Vue.config.productionTip = false;

Vue.use(VueMaterial);
Vue.use(VueParticles);
Vue.use(VueTruncate);
Vue.use(VueTheMask);
Vue.use(SocialSharing);
Vue.use(VeeValidate);

Validator.localize("pt-br", VeePtBr);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
